import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/header.png'


const _withScopeId = n => (_pushScopeId("data-v-4e56939d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"overflow-hidden\" data-v-4e56939d><div class=\"header parallax reverse\" data-strength=\"3\" data-movement=\"absolute\" data-v-4e56939d><div class=\"container\" data-v-4e56939d><header class=\"row overflow-hidden\" data-v-4e56939d><div class=\"header__body position-relative col-12 d-flex flex-column justify-content-center\" data-v-4e56939d><div class=\"row mt-20 mt-lg-0\" data-v-4e56939d><div class=\"col-12 col-lg-6\" data-v-4e56939d><a href=\"https://www.whitlam.org/\" target=\"_blank\" class=\"header__logo mt-20 mb-34 mb-lg-0 mt-lg-34\" data-v-4e56939d><img src=\"" + _imports_0 + "\" class=\"w-100\" alt=\"Whitlam Institute logo\" data-v-4e56939d></a><div class=\"copy parallax reverse\" data-strength=\"15\" data-movement=\"absolute\" data-v-4e56939d><h1 class=\"mb-0\" data-v-4e56939d> Whitlam </h1><p class=\"header__subheading\" data-v-4e56939d> The making of a Prime Minister </p><p class=\"futura\" data-v-4e56939d> Explore how Australia’s 21st Prime Minister was shaped by the people, places and politics that surrounded him from an early age, and discover how these pivotal experiences went on to inform his nation-defining policies. </p></div></div></div></div></header></div><img src=\"" + _imports_1 + "\" alt=\"Gough Whitlam photo\" class=\"w-100 d-block d-lg-none\" data-v-4e56939d></div></div>", 1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" A fortunate early life ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Canberra: A new capital for a changing nation ")
const _hoisted_5 = {
  id: "panel_4",
  class: "bg-white position-relative zindex-5"
}
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { id: "panel_5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Higher")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "d-none d-lg-block" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Education ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Surviving in one piece ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" War in the Pacific ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Indigenous injustice ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" “My finest appointment” ")
const _hoisted_15 = {
  id: "panel_10",
  ref: "panel_10",
  class: "bg-white position-relative zindex-5"
}
const _hoisted_16 = { class: "container" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" A fair go for Australia ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Life in the suburbs ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Post-war suburban sprawl ")
const _hoisted_20 = {
  id: "panel_14",
  ref: "panel_14",
  class: "bg-white position-relative zindex-5"
}
const _hoisted_21 = { class: "container" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" A leader for a changing Labor Party ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" It is feminine to think ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Foreign Relations ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" It’s Time ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" The work continues ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Elder Statesman ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Eternal, not immortal ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Epilogue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Intro = _resolveComponent("Intro")!
  const _component_Waypoint = _resolveComponent("Waypoint")!
  const _component_One = _resolveComponent("One")!
  const _component_Two = _resolveComponent("Two")!
  const _component_Three = _resolveComponent("Three")!
  const _component_Four = _resolveComponent("Four")!
  const _component_Five = _resolveComponent("Five")!
  const _component_Six = _resolveComponent("Six")!
  const _component_Seven = _resolveComponent("Seven")!
  const _component_Nine = _resolveComponent("Nine")!
  const _component_Ten = _resolveComponent("Ten")!
  const _component_Eleven = _resolveComponent("Eleven")!
  const _component_Twelve = _resolveComponent("Twelve")!
  const _component_Thirteen = _resolveComponent("Thirteen")!
  const _component_Fourteen = _resolveComponent("Fourteen")!
  const _component_Fifteen = _resolveComponent("Fifteen")!
  const _component_Sixteen = _resolveComponent("Sixteen")!
  const _component_Seventeen = _resolveComponent("Seventeen")!
  const _component_TwentyOne = _resolveComponent("TwentyOne")!
  const _component_Eighteen = _resolveComponent("Eighteen")!
  const _component_Nineteen = _resolveComponent("Nineteen")!
  const _component_Twenty = _resolveComponent("Twenty")!
  const _component_Epilogue = _resolveComponent("Epilogue")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ContentWarning = _resolveComponent("ContentWarning")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("main", null, [
      _createVNode(_component_Timeline, {
        panel: _ctx.activePanel,
        onSelected: _ctx.timelineUserSelect
      }, null, 8, ["panel", "onSelected"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Waypoint, {
          options: _ctx.waypointOptions,
          onChange: _cache[0] || (_cache[0] = (state) => _ctx.onWaypoint(state, 'panel_1'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Intro, {
              id: "panel_1",
              ref: "panel_1"
            }, null, 512)
          ]),
          _: 1
        }, 8, ["options"]),
        _createVNode(_component_One, {
          id: "panel_2",
          ref: "panel_2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Waypoint, {
              options: _ctx.waypointOptions,
              onChange: _cache[1] || (_cache[1] = (state) => _ctx.onWaypoint(state, 'panel_2'))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["options"])
          ]),
          _: 1
        }, 512)
      ]),
      _createVNode(_component_Two, {
        id: "panel_3",
        ref: "panel_3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[2] || (_cache[2] = (state) => _ctx.onWaypoint(state, 'panel_3'))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Waypoint, {
          ref: "panel_4",
          options: _ctx.waypointOptions,
          onChange: _cache[3] || (_cache[3] = (state) => _ctx.onWaypoint(state, 'panel_4'))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Three)
            ])
          ]),
          _: 1
        }, 8, ["options"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Four, { ref: "panel_5" }, {
          default: _withCtx(() => [
            _createVNode(_component_Waypoint, {
              options: _ctx.waypointOptions,
              onChange: _cache[4] || (_cache[4] = (state) => _ctx.onWaypoint(state, 'panel_5'))
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }, 8, ["options"])
          ]),
          _: 1
        }, 512)
      ]),
      _createVNode(_component_Five, {
        id: "panel_6",
        ref: "panel_6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[5] || (_cache[5] = (state) => _ctx.onWaypoint(state, 'panel_6'))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Six, {
        id: "panel_7",
        ref: "panel_7"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[6] || (_cache[6] = (state) => _ctx.onWaypoint(state, 'panel_7'))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Seven, {
        id: "panel_8",
        ref: "panel_8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[7] || (_cache[7] = (state) => _ctx.onWaypoint(state, 'panel_8'))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Nine, {
        id: "panel_9",
        ref: "panel_9"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[8] || (_cache[8] = (state) => _ctx.onWaypoint(state, 'panel_9'))
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_Waypoint, {
          options: _ctx.waypointOptions,
          onChange: _cache[9] || (_cache[9] = (state) => _ctx.onWaypoint(state, 'panel_10'))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Ten)
            ])
          ]),
          _: 1
        }, 8, ["options"])
      ], 512),
      _createVNode(_component_Eleven, {
        id: "panel_11",
        ref: "panel_11"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[10] || (_cache[10] = (state) => _ctx.onWaypoint(state, 'panel_11'))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Twelve, {
        id: "panel_12",
        ref: "panel_12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[11] || (_cache[11] = (state) => _ctx.onWaypoint(state, 'panel_12'))
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Thirteen, {
        id: "panel_13",
        ref: "panel_13"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[12] || (_cache[12] = (state) => _ctx.onWaypoint(state, 'panel_13'))
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Waypoint, {
          options: _ctx.waypointOptions,
          onChange: _cache[13] || (_cache[13] = (state) => _ctx.onWaypoint(state, 'panel_14'))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Fourteen)
            ])
          ]),
          _: 1
        }, 8, ["options"])
      ], 512),
      _createVNode(_component_Fifteen, {
        id: "panel_15",
        ref: "panel_15"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[14] || (_cache[14] = (state) => _ctx.onWaypoint(state, 'panel_15'))
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Sixteen, {
        id: "panel_16",
        ref: "panel_16"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[15] || (_cache[15] = (state) => _ctx.onWaypoint(state, 'panel_16'))
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Seventeen, {
        id: "panel_17",
        ref: "panel_17"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[16] || (_cache[16] = (state) => _ctx.onWaypoint(state, 'panel_17'))
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_TwentyOne, {
        id: "panel_18",
        ref: "panel_18"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[17] || (_cache[17] = (state) => _ctx.onWaypoint(state, 'panel_18'))
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Eighteen, {
        id: "panel_19",
        ref: "panel_19"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[18] || (_cache[18] = (state) => _ctx.onWaypoint(state, 'panel_19'))
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Nineteen, {
        id: "panel_20",
        ref: "panel_20"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[19] || (_cache[19] = (state) => _ctx.onWaypoint(state, 'panel_20'))
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Twenty, {
        id: "panel_21",
        ref: "panel_21"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Waypoint, {
            options: _ctx.waypointOptions,
            onChange: _cache[20] || (_cache[20] = (state) => _ctx.onWaypoint(state, 'panel_21'))
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_Epilogue, null, {
        default: _withCtx(() => [
          _hoisted_29
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Footer),
    _createVNode(_component_ContentWarning)
  ]))
}